// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const nin: CountryValidator<"NG"> = createValidator(
  "ng.nin",
  132,
);

export default nin;
export const compact = nin.compact;
export const format = nin.format;
export const validate = nin.validate;
export const generate = (): string =>
  nin.generate?.() ??
  (() => {
    throw new Error(
      "Validator ng.nin cannot generate values",
    );
  })();
